import { render, staticRenderFns } from "./LegalNoticeScreen.vue?vue&type=template&id=62612730&scoped=true"
import script from "./LegalNoticeScreen.vue?vue&type=script&lang=js"
export * from "./LegalNoticeScreen.vue?vue&type=script&lang=js"
import style0 from "./LegalNoticeScreen.vue?vue&type=style&index=0&id=62612730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62612730",
  null
  
)

export default component.exports